/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * Contact: redjar.redelivery@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface AdminPutBody { 
    cdAdmin?: number;
    dsName: string;
    dsEmail: string;
    dsUsername?: string;
    dsNewLogo?: string;
    logo?: Blob;
    dsFb?: string;
    dsInsta?: string;
    dsTwitter?: string;
    dsYoutube?: string;
    dsSmsApi?: string;
    dsCurrency?: string;
    dsApiMeli?: string;
    dsMeliPublicKey?: string;
}